<!-- 错题页面容器 -->
<template>
  <div class="container">
    <Head></Head>
    <div class="Box">
      <div class="tabBox">
        <div class="quseBox">
          <div class="questions">
            <div class="currhead">
              <!-- 当前课程 -->
              <h1 class="currh1">{{courseName}}</h1>
              <div @click="slices" class="currfont" style="cursor: pointer;">
                返回
                <img alt src="@/assets/img/slices/slices.png" style="margin-left: 10px;" />
              </div>
            </div>
            <div class="titcent">
              <!-- 当前试卷 -->
              <img alt src="@/assets/img/icon.png" />
              {{ExaminationInfo.examinationName}}
            </div>
            <div>
              <div class="question_box better-scroll-bar">
                <div
                  :id="'parsing' + item.examinationItemId"
                  :key="item.examinationItemId"
                  v-for="item in showItemList"
                >
                  <!-- 单选题 -->
                  <RadioWarning
                    :bankData="item"
                    :courseId="courseId"
                    :status="true"
                    :topTypeId="ExaminationInfo.topTypeId"
                    :typeText="'单选题'"
                    v-if="Number(item.questionType) === 1"
                    v-on:setCollect="setCollect"
                  ></RadioWarning>
                  <!-- 多选题 -->
                  <CheckWarning
                    :courseId="courseId"
                    :examinationItemData="item"
                    :status="true"
                    :topTypeId="ExaminationInfo.topTypeId"
                    :typeText="'多选题'"
                    v-else-if="Number(item.questionType) === 2"
                    v-on:setCollect="setCollect"
                  ></CheckWarning>
                  <!-- 判断题 -->
                  <RadioWarning
                    :bankData="item"
                    :courseId="courseId"
                    :status="true"
                    :topTypeId="ExaminationInfo.topTypeId"
                    :typeText="'判断题'"
                    v-else-if="Number(item.questionType) === 3"
                    v-on:setCollect="setCollect"
                  ></RadioWarning>
                </div>
              </div>
            </div>
          </div>
          <div class="answerSheet">
            <!-- 右侧列表 -->
            <WarningControl
              :count="count"
              :numCount="num"
              :selectData="dataAll"
              :status="true"
              :warninges="warninges"
            ></WarningControl>
          </div>
        </div>
        <div class="question_page">
          <el-pagination
            :current-page.sync="page"
            :next-text="`下一页`"
            :page-size="5"
            :prev-text="`上一页`"
            :total="count"
            @current-change="handleCurrentChange"
            layout="prev, next"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Head from '@/components/pc/Head'
import WarningControl from '@/components/pc/questionBank/WarningControl'
import RadioWarning from '@/components/pc/questionBank/RadioWarning'
import CheckWarning from '@/components/pc/questionBank/CheckWarning'
import * as QUESTION_API from '@/api/ExaminationAPI'
export default {
  data () {
    return {
      warninges: true,
      selectCount: 0,
      showItemList: [],          //错题显示列表
      showItemCopyList: [],      //错题答题显示列表
      examinationId: '',         //题目id
      ExaminationInfo: {},
      courseName: '',
      itemCount: 0,                 //题目总数量
      examinationItemList: [],    //试题集合

      copyData: '',
      dataAll: '',
      activeName: 'first',
      initList: '',
      liData: '',
      page: 1,
      pagesize: 5,
      count: 0,
      date: '',
      isLeaval: false,
      numCount: 0,
      num: 0,
      numTime: 0,
      prePath: sessionStorage.getItem('prePath') || '',
      push_status: false,
      is_show: true,
      pushType: 2,
      sessionData: [],
      courseId: 0
    }
  },
  components: {
    WarningControl,
    RadioWarning,
    CheckWarning,
    Head
  },
  computed: {},
  beforeRouteEnter (to, from, next) {
    //  这里的vm指的就是vue实例，可以用来当做this使用
    next(vm => {
      if (from.path.length > 2) {
        sessionStorage.setItem('prePath', from.path)
        vm.prePath = from.path
      }
    })
  },
  created () {
    //从课程详细页面错题跳转此页面
    if (this.$route.params.parsingObj) {
      this.ExaminationInfo = this.$route.params.examination
      this.courseName = this.$route.params.courseName
      this.courseId=this.$route.params.courseId
    } else {
      this.ExaminationInfo = JSON.parse(sessionStorage.getItem('warning')).examination
      this.courseName = JSON.parse(sessionStorage.getItem('warning')).courseName
      this.courseId=JSON.parse(sessionStorage.getItem('warning')).courseId
    }

    console.log(this.ExaminationInfo)
    this.examinationId = this.ExaminationInfo.examinationId
    this.initData()
  },
  mounted () {
    window.addEventListener('setItem', e => {
      let active = ''
      if (e.key === 'active_an') {
        active = JSON.parse(sessionStorage.getItem('active_an'))
        this.page = Math.ceil(active.index / 5)
        this.showItemList = []
        this.showItemList = this.dataAll.slice(Number((this.page - 1) * this.pagesize), Number(this.page * this.pagesize))
        this.showItemCopyList = this.copyData.slice(Number((this.page - 1) * this.pagesize), Number(this.page * this.pagesize))
      } else {
        console.log(e.key, '我在输出else')
      }
    })
  },
  watch: {
    numCount (val) {
      if (val > 0) {
        this.is_submit = false
      }
    }
  },
  methods: {
    // 点击选项获取答案
    getChildVal (obj) {
      if (obj.examinationItemId) {
        this.lastExaminationItemId = obj.examinationItemId
        for (let i = 0; i < this.copyData.length; i++) {
          if (this.copyData[i].examinationItemId === obj.examinationItemId) {
            if (obj.select instanceof Array) {
              //如果是多选题
              if (obj.select.length > 0) {
                this.copyData[i].select = obj.select.sort().toString().replace(/[,]/g, '###')
              } else {
                this.copyData[i].select = ''
              }
            } else {
              this.copyData[i].select = obj.select
            }
            this.copyData[i].show = true

          }
        }
        sessionStorage.setItem('copyData', JSON.stringify(this.copyData))
      }
    },
    // 初始化数据
    initData () {
      const loading = this.$loading({
        text: '数据加载中……'
      });
      let params = {
        examinationId: this.examinationId,
        type: 3,
        withTestLog: true,//查询用户答题数据需要字段
        wrongOnly: true, //只查看错题题目
        withCollect: true,
        courseId: this.courseId
      }

      QUESTION_API.examinationItemWrong(params).then(res => {
        loading.close();
        if (res && Number(res.code) === 0) {
          this.examinationItemList = res.data;
          this.itemCount = this.examinationItemList.length
          this.count = res.data.length
          let data = []
          let copy = []
          for (let i = 0; i < this.examinationItemList.length; i++) {
            data[i] = this.examinationItemList[i]
            data[i].order = (i + 1)
            copy[i] = this.examinationItemList[i]
            copy[i].order = (i + 1)
            copy[i].show = false
          }
          this.dataAll = data
          this.copyData = copy
          // 保证刷新后用户的数据不丢失
          if (sessionStorage.getItem('copyData')) {
            this.sessionData = JSON.parse(sessionStorage.getItem('copyData'))
            for (let i = 0; i < this.sessionData.length; i++) {
              for (let s = 0; s < this.copyData.length; s++) {
                if (this.sessionData[i].examinationItemId === this.copyData[s].examinationItemId) {
                  if (this.sessionData[i].select instanceof Array) {
                    if (this.sessionData[i].select.length > 0 && this.sessionData[i].show === true) {
                      this.copyData[s] = this.sessionData[i]

                    } else {
                      this.copyData[s].select = ''
                    }
                  } else {
                    if (this.sessionData[i].select && this.sessionData[i].show === true) {
                      this.copyData[s] = this.sessionData[i]
                    } else {
                      this.copyData[s].select = ''
                    }
                  }
                }
              }
            }
          }

          this.showItemList = this.dataAll.slice((this.page - 1) * this.pagesize, this.page * this.pagesize)

          this.showItemCopyList = this.copyData.slice((this.page - 1) * this.pagesize, this.page * this.pagesize)
        } else {
          this.$message.warning(res.msg)
        }


      }).catch(err => {
        loading.close();
        console.log(err)
      })
    },
    slices () {
      this.$router.back()
    },

    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.page = val
      this.showItemList = []
      this.showItemList = this.dataAll.slice(Number((this.page - 1) * this.pagesize), Number(this.page * this.pagesize))
      this.showItemCopyList = this.copyData.slice(Number((this.page - 1) * this.pagesize), Number(this.page * this.pagesize))
    },

    //题目中收藏按钮点击回调事件
    setCollect (obj) {
      console.log(444444)
      console.log(obj.push)
      if (obj.push) {
        for (let i = 0; i < this.dataAll.length; i++) {
          if (Number(obj.examinationItemId) === Number(this.dataAll[i].examinationItemId)) {
            this.dataAll[i].isCollect = obj.collect
          }
        }
        this.showItemList = this.dataAll.slice(Number((this.page - 1) * this.pagesize), Number(this.page * this.pagesize))
      }
    },

  },

  beforeRouteLeave (to, form, next) {
    next()
  },
  destroyed () {
    sessionStorage.removeItem('active_an')
    sessionStorage.removeItem('copyData')
    sessionStorage.removeItem('prePath')
  }
}
</script>
<style scoped>
.question_box {
  height: 500px;
  overflow: auto;
}
.titcent {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px;
}
.titcent img {
  margin-right: 16px;
}
.currhead {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.currh1 {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 64px;
}
.quseBox {
  display: flex;
  justify-content: space-between;
}
.questions {
  width: 844px;
  height: 780px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  padding: 40px;
}
.answerSheet {
  width: 425px;
  height: 780px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
}
.tabBox {
  max-width: 1282px;
  margin: 0 auto;
  margin-top: 30px;
}
::v-deep .el-tabs__nav-wrap::after {
  height: 0px;
}
::v-deep .el-pagination button:disabled {
  margin-right: 10px;
}
::v-deep .el-pagination {
  margin: 20px 0;
}
</style>
